module.exports = __webpack_public_path__ + "img/r-111.1a65d17f.jpg";